// Expands NorthStar shorthand and 5G acronyms before a query reaches the API,
// so the model is not left guessing what "RRP" or "5QI" means.
//
// Shared with scripts/build-precomputed-answers.mjs: a precomputed answer is
// keyed by the expanded query, so both sides must expand identically or every
// lookup misses and falls back to a live call.
export function expandQuery(query) {
  let expanded = query;

  // Replace terms
  expanded = expanded.replace(/\bnorthstar\b/gi, 'NorthStar 5G Innovation Network');
  expanded = expanded.replace(/\bverticals\b/gi, 'verticals including healthcare');
  expanded = expanded.replace(/\RRP\b/gi, 'Radio Resource Partitioning');

  expanded = expanded.replace(
    /\bNorthStar partners\b/gi,
    'organizations who have joined the NorthStar 5G Innovation Network'
  );

  // Replace 5G acronyms with full expansions
  expanded = expanded.replace(/\b5QI\b/g, '5QI (5G QoS Identifier)');
  expanded = expanded.replace(/\bAMF\b/g, 'AMF (Access and Mobility Management Function)');
  expanded = expanded.replace(/\bDNN\b/g, 'DNN (Data Network Name)');
  expanded = expanded.replace(/\bEBO\b/g, 'EBO (Edge Break-Out)');
  expanded = expanded.replace(/\bENL\b/g, 'ENL (Ericsson Network Location)');
  expanded = expanded.replace(/\bgNB\b/g, 'gNB (Next-generation Node B, 5G base station)');
  expanded = expanded.replace(/\bKPI\b/g, 'KPI (Key Performance Indicator)');
  expanded = expanded.replace(/\bL4S\b/g, 'L4S (Low Latency Low Loss Scalable throughput)');
  expanded = expanded.replace(/\bLPG\b/g, 'LPG (Local Packet Gateway)');
  expanded = expanded.replace(/\bMNO\b/g, 'MNO (Mobile Network Operator)');
  expanded = expanded.replace(/\bQoE\b/g, 'QoE (Quality of Experience)');
  expanded = expanded.replace(/\bQoS\b/g, 'QoS (Quality of Service)');
  expanded = expanded.replace(/\bRAN\b/g, 'RAN (Radio Access Network)');
  expanded = expanded.replace(/\bRSRP\b/g, 'RSRP (Reference Signal Received Power)');
  expanded = expanded.replace(/\bRSRQ\b/g, 'RSRQ (Reference Signal Received Quality)');
  expanded = expanded.replace(/\bRTT\b/g, 'RTT (Round-Trip Time)');
  expanded = expanded.replace(/\bSINR\b/g, 'SINR (Signal-to-Interference-plus-Noise Ratio)');
  expanded = expanded.replace(/\bSMF\b/g, 'SMF (Session Management Function)');
  expanded = expanded.replace(
    /\bS-NSSAI\b/g,
    'S-NSSAI (Single Network Slice Selection Assistance Information)'
  );
  expanded = expanded.replace(/\bUDM\b/g, 'UDM (Unified Data Management)');
  expanded = expanded.replace(/\bUE\b/g, 'UE (User Equipment)');
  expanded = expanded.replace(/\bUPF\b/g, 'UPF (User Plane Function)');
  expanded = expanded.replace(/\bDL\b/g, 'DL (Downlink)');
  expanded = expanded.replace(/\bUL\b/g, 'UL (Uplink)');
  expanded = expanded.replace(/\bNR\b/g, 'NR (New Radio, 5G radio access)');

  return expanded;
}
